import {
  requestGetProviderNamePrediction,
  requestGetProviderCategories,
  requestGetproviderSearchData,
  requestGetproviderSearchDataByName,
  requestGetCptCodeSuggestion,
  requestGetProviderSearchDataByCptCode,
  requestGetProviderApiCallCountByClient,
  requestGetProviderSearchDataByFacility,
  requestAddProviderComment,
  requestGetProviderComment,
  requestAddProviderLikeFeedback,
  requestUserActivities,
  requestUsersActivities,
  requestProviderSearchDataByNpi,
  requestAddClaim,
  requestNPIBackgroundActivities,
} from "../requests/provider";
import { call, put } from "redux-saga/effects";

import {
  setProviderCategoryData,
  setProviderSearchData,
  setLoaderState,
  setInputLoaderState,
  setProviderNamePrediction,
  setCptCodeSuggestion,
  setProviderApiCallCountByClient,
  setProviderComment,
  setAddProviderComment,
  setAddProviderClaim,
  getProviderComment,
  setAddLikeFeedback,
  setUserActivity,
  setAILoaderState,
  setAiSearchResult,
} from "../../ducks/provider";

import { setUserAuthentication, setUserForbidden } from "../../ducks/auth";

import { Authentication } from "../../../utils/authentication";

export function* handleGetProviderCategory(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestGetProviderCategories);
    const { data } = response;
    yield put(setProviderCategoryData([...data]));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
  }
}

export function* handleGetProviderApiCallCountByClient(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(
      requestGetProviderApiCallCountByClient,
      action.ClientId
    );
    const { data } = response;
    yield put(setProviderApiCallCountByClient({ ...data }));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    yield put(setProviderApiCallCountByClient({}));
    if (error.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    if (error?.response?.status === 403) {
      yield put(setUserForbidden(true));
    }
  }
}

export function* handleGetProviderSearchData(action) {
  try {
    yield put(setProviderSearchData({}));
    yield put(setLoaderState(true));
    const response = yield call(requestGetproviderSearchData, action.payload);
    const { data } = response;
    yield put(setProviderSearchData({ ...data.item }));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

export function* handleGetProviderSearchDataByName(action) {
  try {
    yield put(setProviderSearchData({}));
    yield put(setLoaderState(true));
    const response = yield call(
      requestGetproviderSearchDataByName,
      action.payload
    );
    const { data } = response;
    yield put(setProviderSearchData({ ...data.item }));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

export function* handleGetProviderSearchDataByNpi(action) {
  try {
    yield put(setProviderSearchData({}));
    yield put(setLoaderState(true));
    const response = yield call(requestProviderSearchDataByNpi, action.payload);
    const { data } = response;
    yield put(setProviderSearchData({ ...data.item }));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

export function* handleGetProviderNamePrediction(action) {
  try {
    yield put(setInputLoaderState(true));
    yield put(setProviderNamePrediction([]));
    const response = yield call(
      requestGetProviderNamePrediction,
      action.payload
    );
    const { data } = response;
    yield put(setProviderNamePrediction([...data.items]));
    yield put(setInputLoaderState(false));
  } catch (error) {
    yield put(setInputLoaderState(false));
    yield put(setProviderNamePrediction([]));
  }
}

export function* handleGetCptSuggestion(action) {
  try {
    yield put(setInputLoaderState(true));
    yield put(setCptCodeSuggestion([]));
    const response = yield call(requestGetCptCodeSuggestion, action.payload);
    const { data } = response;
    yield put(setCptCodeSuggestion([...data.items]));
    yield put(setInputLoaderState(false));
  } catch (error) {
    yield put(setInputLoaderState(false));
    yield put(setCptCodeSuggestion([]));
  }
}

export function* handleGetProviderSearchDataByCPT(action) {
  try {
    yield put(setProviderSearchData({}));
    yield put(setLoaderState(true));
    const response = yield call(
      requestGetProviderSearchDataByCptCode,
      action.payload
    );
    const { data } = response;
    yield put(setProviderSearchData({ ...data.item }));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

export function* handleGetProviderSearchDataByFacility(action) {
  try {
    yield put(setProviderSearchData({}));
    yield put(setLoaderState(true));
    const response = yield call(
      requestGetProviderSearchDataByFacility,
      action.payload
    );
    const { data } = response;
    yield put(setProviderSearchData({ ...data.item }));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

export function* handleGetProviderComment(action) {
  try {
    yield put(setProviderComment([]));
    yield put(setLoaderState(true));
    const response = yield call(requestGetProviderComment, action.payload);
    const { data } = response;
    yield put(setProviderComment({ ...data.item }));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error?.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

export function* handleAddProviderComment(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestAddProviderComment, action.payload);
    const { data } = response;
    yield put(setAddProviderComment({ ...data.item }));
    yield put(getProviderComment(action.payload.npi));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

export function* handleAddProviderClaim(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestAddClaim, action.payload);
    const { data } = response;
    yield put(setAddProviderClaim({ ...data.item }));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

export function* handleAddProviderLikeFeedback(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestAddProviderLikeFeedback, action.payload);
    const { data } = response;
    yield put(setAddLikeFeedback({ ...data.items }));
    yield put(getProviderComment(action.payload.npi));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

// this handles to get the user specific activity
export function* handleGetUserActivity(action) {
  try {
    yield put(setLoaderState(true));
    yield put(setUserActivity([]));
    const response = yield call(requestUserActivities);
    const { data } = response;
    yield put(setUserActivity([...data.items]));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}

// this is to get the npi background research data
export function* handleGetNPIActivity(action) {
  try {
    yield put(setAILoaderState(true));
    yield put(setAiSearchResult({}));
    const response = yield call(requestNPIBackgroundActivities, action.payload);
    console.log(response, "checking response");
    const { data } = response;
    yield put(setAiSearchResult(data.item));
    yield put(setAILoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setAILoaderState(false));
  }
}

// this handles to get the all user activity from client id
export function* handleGetUsersActivity() {
  try {
    yield put(setLoaderState(true));
    yield put(setUserActivity([]));
    const response = yield call(requestUsersActivities);
    const { data } = response;
    yield put(setUserActivity([...data.items]));
    yield put(setLoaderState(false));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    yield put(setLoaderState(false));
  }
}
